import { FC, ReactNode } from "react";
import styles from "./styles.module.scss";
import uniqid from "uniqid";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import btnClasses from "../../atoms/my-button/styles.module.scss";

export interface CardContainerProps {
  data: CardProps[];
  root: string;
}

export interface CardProps {
  slug: string;
  id: number | string;
  image: StaticImageData | string;
  children: ReactNode | JSX.Element | FC;
  alt?: string;
  url?: string;
}

const Card: FC<CardProps> = ({ image, children, alt, url, slug }) => {
  const handleMouseOut = () => {
    const buttonEL = document.getElementById(slug);
    if (buttonEL) {
      buttonEL.classList.remove(btnClasses.hover_animation);
    }
  };

  const handleMouseEnter = () => {
    const buttonEL = document.getElementById(slug);
    if (buttonEL) {
      buttonEL.classList.add(btnClasses.hover_animation);
    }
  };

  return (
    <Link
      href={url || ""}
      className={styles.card}
      onMouseOver={handleMouseEnter}
      onMouseOut={handleMouseOut}
    >
      <div className={styles.image_container}>
        <div className={styles.bg_orange} />
        <div className={styles.img_container}>
          <Image src={image} alt={alt || ""} />
        </div>
      </div>
      <div className={styles.contents}>
        {typeof children === "function"
          ? (children as any)({ id: slug })
          : children}
      </div>
    </Link>
  );
};

export const CardContainer: FC<CardContainerProps> = ({ data = [], root }) => {
  const left = data
    .filter((_, index) => index % 2 === 0)
    .map((el) => ({ ...el, url: `${root}/${el.slug}` }));
  const right = data
    .filter((_, index) => index % 2 !== 0)
    .map((el) => ({ ...el, url: `${root}/${el.slug}` }));
  const myData = data.map((el) => ({ ...el, url: `${root}/${el.slug}` }));

  return (
    <div className={styles.card_container}>
      <div className={styles.desktop}>
        <div className={styles.left}>
          {left.map((el) => (
            <Card key={uniqid()} {...el} />
          ))}
        </div>
        <div className={styles.right}>
          {right.map((el) => (
            <Card key={uniqid()} {...el} />
          ))}
        </div>
      </div>
      <div className={styles.mobile}>
        {myData.map((el) => (
          <Card key={uniqid()} {...el} />
        ))}
      </div>
    </div>
  );
};
